







import { defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import DynamicNavigation from '~/components/Navigation/DynamicNavigation.vue';
import AllPackagesSection from '~/components/sections/AllPackagesSection.vue';
import { buildSeoHead } from '~/helpers/buildSeoHead';
import { Breadcrumb } from '../types';

export default defineComponent({
  name: 'AnalysesPage',
  components: {
    DynamicNavigation,
    AllPackagesSection,
  },
  setup() {
    const { localePath, i18n } = useContext();
    const breadcrumbs = ref<Breadcrumb[]>([
      {
        text: i18n.t('Home') as string,
        link: localePath('/'),
      },
      {
        text: i18n.t('Analysis packages') as string,
        link: localePath('/provanalyser'),
      },
    ]);
    return {
      breadcrumbs,
    };
  },
  head: buildSeoHead({ title: 'Blodprov' }),
});
